import { WaitlistForm } from "@/components/landing/waitlist/WaitlistForm";
import { WaitlistLayout } from "@/components/landing/waitlist/WaitlistLayout";

/**
 * /rate-check - where the rate check Meta ads land. Name and email open the
 * practice questions, and "Get my free rate check" under them sends the
 * request and shows the booking calendar; the details the check needs come on
 * the call.
 */
export default function RateCheckPage() {
  return (
    <WaitlistLayout
      documentTitle="Altair · Free insurer rate check"
      title="Not happy with your rates?"
      subhead="We'll help you get better ones."
    >
      <WaitlistForm
        page="rate-check"
        submitLabel="Get my free rate check"
        doneTitle="Request received."
        doneNote="Book a call with the team."
        maxWidth={680}
      />
    </WaitlistLayout>
  );
}
